import { useContext, useEffect, useRef, useState } from "react";
import QuestWhiteLogo from "../../assets/images/QuestWhiteLogo.svg";
import HelphubSvg from "./CustomHelphubSvg";
import { Conversation, HelpHubChatTypes, MessageTypes } from "./CustomHelpHub.type";
import QuestContext from "../QuestWrapper";
import {
  getMessages,
  handleFeedbackRatings,
  sendMessage,
} from "./CustomHelphub.service";
import config from "../../config";
import { uploadImageToBackend, useGeneral } from "../../general";
import audio1 from "../../assets/audio/audio1.mp3";
import audio2 from "../../assets/audio/audio2.wav";

import HandleAdminChat from "./components/HandleAdminChat";
import HandleUserChat from "./components/HandleUserChat";
import { checkForCloseChat, hexToGlassColor } from "./components/helperfunction";

let SenderImg =
  "https://s3-alpha-sig.figma.com/img/c73b/ede1/44dae2a681a58d566da9f69147cc690d?Expires=1713744000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=XJcQc8XNhFza8CJhDAyWRNg9DCoXlrD4E2wn1JDTXS4GFD3XmwsrPggispX-rCLfIw~LJAZGJVvog4bAZ7y5T2UHfn7SkPWSqTZrCftSeZzVjMTej3u5y3ZL28S3tIekwU9BZ3fzSe1HgprPHdZNCxMgOlqyhA6pb9tCSQ6Vu0Z7W8z9Hh6OmCJje68iaAro9DsHtu~wvstZjyfEENlhWWG4wMK5tZTw3hRBYKAmSExdiFb25DjhBUG~cHoXYV6A5286pwskNTO0QrPHULje839o8TdBKsvI4CC2v7yCiYC1V7Qlcd-h6GH-P0DL2qfttlIlZD3frTKsnW1EA-0PHQ__";

const DEFAULT_MESSAGES: Conversation[] = [
  {
    senderRole: "SYSTEM",
    senderId: "system",
    content: "Hi there! I'm AVA, your guide to Freedom World. Whether you have questions about the platform or need help with your community, I've got you covered.",
    timestamp: new Date().toISOString(),
  },
  {
    senderRole: "ASSISTANT",
    senderId: "assistant",
    content: "How can I help?",
    timestamp: new Date().toISOString(),
  },
]

const CustomHelpHubChat = (props: HelpHubChatTypes) => {
  const {
    contentConfig,
    styleConfig,
    apiType,
    apiKey,
    entityId,
    token,
    userId,
    setShowBottomNavigation,
    entityImage,
    entityName,
    setHelpHub,
    uniqueUserId,
    uniqueEmailId,
    position,
    sendAutoMessage,
    setSendAutoMessage,
    chat,
    setChat,
    filterChat,
    setFilterChat,
    fetchData,
    entityAuthenticationToken,
    defaultAutoPopupMessagesApi = [],
    isPopMessageAudio,
    setOpenCloseChatPopup,
    openCloseChatPopup,
    isActive,
    BrandTheme,
    QuestThemeData,
    isOffline,
    setPositionInLocal,
    onClose,
  } = props;

  const { themeConfig, user } = useContext(QuestContext.Context);
  const [showPersonalChat, setShowPersonalChat] = useState(false);
  const [message, setMessage] = useState("");
  const [data, setData] = useState<Conversation[]>(DEFAULT_MESSAGES);
  const scrollRef = useRef<HTMLDivElement>(null);
  const [senderMessageLoading, setSenderMessageLoading] = useState(false);

  let BACKEND_URL =
    apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL;

  const [scrollWidthSet, setScrollWidthSet] = useState<boolean>(true);
  const [selectedConversationId, setSelectedConversationId] =
    useState<string>("");
  const [onlyAdminReply, setOnlyAdminReply] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const [adminMsg, setAdminMsg] = useState<boolean>(false);
  const [ifSatisfied, setIfSatisfied] = useState<boolean>(false);
  const [searchData, setSearchData] = useState<string | number>("");
  const [disableSendMessageBtn, setDisableSendMessageBtn] =
    useState<boolean>(false);
  const messageInputRef = useRef<HTMLInputElement>(null);
  const [openEmailCollection, setOpenEmailCollection] =
    useState<boolean>(false);
  const [chatClosed, setChatClosed] = useState<boolean>(false);
  const [isCloseChatAdmin, setCloseChatAdmin] = useState(false);
  const general = useGeneral('quest');
  const [isEnterToSend, setIsEnterToSend] = useState(localStorage.getItem("isEnterToSend") === "true" ? true : false);

  const sendAutoMessageFromUser = async () => {
    if (sendAutoMessage != "") {
      setUpdateOutAnimation(true);
      setScrollWidthSet((prev) => !prev);
      setTimeout(() => {
        setData([]);
        setSelectedConversationId("");
        setShowPersonalChat((prev) => !prev);
        setShowBottomNavigation && setShowBottomNavigation((prev) => !prev);
        setUpdateOneOutAnimation(false);
        setScrollWidthSet((prev) => !prev);
        sendMessageFunc(sendAutoMessage || "");
      }, 100);
      setSendAutoMessage && setSendAutoMessage("");
    }
  };

  const handleRating = async (feedbackRate: number) => {
    let getRating = await handleFeedbackRatings({
      conversationId: selectedConversationId,
      feedbackRate: feedbackRate,
      entityId: entityId,
      userId: userId,
      token: token,
      apikey: apiKey,
      backend_url: BACKEND_URL,
      uniqueUserId: uniqueUserId,
      uniqueEmailId: uniqueEmailId,
      apiType: apiType,
      entityAuthenticationToken: entityAuthenticationToken,
    });

    if (getRating?.success) {
      let newChat = filterChat?.map((ele) => {
        if (ele.conversationId == selectedConversationId) {
          return {
            ...ele,
            feedbackRate: feedbackRate,
          };
        } else {
          return ele;
        }
      });
      newChat && setFilterChat && setFilterChat(newChat);
      setScrollWidthSet((prev) => !prev);
      setUpdateOneOutAnimation((prev) => !prev);
      setUpdateOutTempAnimation(true);
      setChatClosed(true);
      setIfSatisfied(() => false);
      setTimeout(() => {
        setShowBottomNavigation && setShowBottomNavigation(true);
        setUpdateOutAnimation(false);
        setShowPersonalChat(false);
      }, 250);
    }
  };

  const [sendAutoMessage2, setSendAutoMessage2] = useState<string>("");

  const sendAutoMessageFromUser2 = async () => {
    if (sendAutoMessage2 != "") {
      setScrollWidthSet((prev) => !prev);
      sendMessageFunc(sendAutoMessage2 || "");
      setSendAutoMessage && setSendAutoMessage("");
    }
  };

  useEffect(() => {
    if (isOffline) return;
    general.trackEvent(
      "quest-helphub-chat-loaded",
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    );
  }, []);

  useEffect(() => {
    sendAutoMessageFromUser();
  }, [sendAutoMessage]);

  useEffect(() => {
    sendAutoMessageFromUser2();
  }, [sendAutoMessage2]);

  useEffect(() => {
    messageInputRef.current?.focus();
  }, [chat, disableSendMessageBtn]);

  const storeLastChat = (chatHistory: MessageTypes[]) => {
    let lastSeenRecord: { [key: string]: string } = JSON.parse(
      localStorage.getItem("lastSeenRecord") || "{}"
    );
    (chatHistory || chat)?.forEach((ele) => {
      lastSeenRecord[ele.conversationId] = ele?.conversations?.content;
    });
    localStorage.setItem("lastSeenRecord", JSON.stringify(lastSeenRecord));
  };

  const filterByLastMessage = (chatData: MessageTypes[]) => {
    let data = chatData.sort((a, b) => {
      return (
        new Date(b?.conversations?.timestamp).getTime() -
        new Date(a?.conversations?.timestamp).getTime()
      );
    });

    return data;
  };

  useEffect(() => {
    let updateChat =
      chat?.filter((ele) => ele.conversationId == selectedConversationId) || [];
    if (updateChat?.length > 0) {
      setOnlyAdminReply(updateChat[0]?.onlyAdminReply);
    }
  }, [data]);

  const audioPlay = (value: boolean) => {
    let play = value ? audio1 : audio2;
    const audio = new Audio(play);
    audio.volume = 0.15;
    audio.play().catch((error) => {
      console.error("Error playing the audio:", error);
    });
  };

  async function sendMessageFunc(message: string) {
    if (disableSendMessageBtn) {
      return;
    }
    setSenderMessageLoading(true);
    setDisableSendMessageBtn(true);
    setOpenEmailCollection(false);
    setAdminMsg(false);
    setIfSatisfied(false);

    let userChat: Conversation = {
      senderRole: "USER",
      _id: new Date().toISOString(),
      senderId: userId || "",
      content: message,
      timestamp: new Date().toISOString(),
    };
    isPopMessageAudio && audioPlay(true);
    setData((data: Conversation[]) => [...data, userChat]);
    let updateLastChat: MessageTypes[] | [] = chat || [];
    if (selectedConversationId) {
      updateLastChat =
        chat?.map((ele) => {
          if (ele.conversationId == selectedConversationId) {
            return {
              ...ele,
              conversations: userChat,
            };
          } else {
            return ele;
          }
        }) || [];
      setChat && setChat(filterByLastMessage(updateLastChat));
      setFilterChat && setFilterChat(filterByLastMessage(updateLastChat));
      storeLastChat(updateLastChat || []);
    }

    let sendMessageResponse = await sendMessage(
      BACKEND_URL,
      entityId,
      userId,
      token,
      apiKey,
      message,
      selectedConversationId,
      uniqueUserId,
      uniqueEmailId,
      apiType,
      entityAuthenticationToken
    );

    if (sendMessageResponse?.data?.replied) {
      if (!selectedConversationId) {
        setSelectedConversationId(
          sendMessageResponse?.data?.conversationData?.conversationId
        );
      }
      let conId = selectedConversationId || sendMessageResponse?.data?.conversationData?.conversationId;
      if (sendMessageResponse?.data?.message) {
        setData((data) => [...data, sendMessageResponse?.data?.message]);
      }
      let findData = false;
      updateLastChat = chat?.map((ele) => {
        if (ele.conversationId == conId) {
          findData = true;
          return {
            ...ele,
            conversations: sendMessageResponse?.data?.message || sendMessageResponse?.data?.conversationData?.conversations[sendMessageResponse?.data?.conversationData?.conversations.length - 1],
            ...(!!sendMessageResponse?.data?.conversationData?.title &&
              !title && {
              title: sendMessageResponse?.data?.conversationData?.title || "",
            }),
          };
        } else {
          return ele;
        }
      }) || [];

      if (!findData) {
        let newChat = sendMessageResponse?.data?.conversationData;
        newChat.conversations = sendMessageResponse?.data?.message || sendMessageResponse?.data?.conversationData?.conversations[sendMessageResponse?.data?.conversationData?.conversations.length - 1];
        updateLastChat = [...updateLastChat, newChat];
      }
    }
    isPopMessageAudio && !onlyAdminReply && audioPlay(false);

    setChat && setChat(filterByLastMessage(updateLastChat));
    setFilterChat && setFilterChat(filterByLastMessage(updateLastChat));
    storeLastChat(updateLastChat || []);
    setSenderMessageLoading((prev) => !prev);
    setDisableSendMessageBtn((prev) => !prev);
  }

  const handleSave = () => {
    if (message.length > 0) {
      sendMessageFunc(message);
    }
    setMessage("");
  };

  const resizeHandler = () => {
    const headerElement = document.getElementById("helpHub");
    if (headerElement && scrollRef.current) {
      const headerHeight =
        position == "POPUP" ? headerElement.clientHeight : window.innerHeight;
      scrollRef.current.style.height = headerHeight - 191 + "px";
    }
  };

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
    resizeHandler();
  }, [
    data,
    scrollWidthSet,
    position,
    ifSatisfied,
    isCloseChatAdmin,
    chatClosed,
  ]);

  useEffect(() => {
    window.addEventListener("resize", resizeHandler);
    resizeHandler();
    return () => window.removeEventListener("resize", resizeHandler);
  }, []);

  const getMessagesHistory = async (conversationId: string | undefined) => {
    if (conversationId) {
      setLoading(true);
      setSelectedConversationId(conversationId);
      let getResult: {
        data: { conversations: Conversation[]; title?: string };
      } | any = await getMessages(
        BACKEND_URL,
        entityId,
        userId,
        token,
        apiKey,
        conversationId || "",
        uniqueUserId,
        uniqueEmailId,
        apiType,
        entityAuthenticationToken
      );
      setData(getResult?.data?.conversations);
      setChat?.(chats => chats.map(c => c.conversationId === conversationId ? { ...c, isReadByUser: true } : c));
      setFilterChat?.(chats => chats.map(c => c.conversationId === conversationId ? { ...c, isReadByUser: true } : c));
      setLoading(false);
      if (!!getResult?.data?.title && !title) {
        setTitle(getResult?.data?.title);
      }
    }
  };

  const [updateOutAnimation, setUpdateOutAnimation] = useState<boolean | null>(
    null
  );
  const [updateOneoutAnimation, setUpdateOneOutAnimation] = useState<
    boolean | null
  >(null);
  const [updateOutTempAnimation, setUpdateOutTempAnimation] = useState<
    boolean | null
  >(null);

  useEffect(() => {
    let data =
      chat &&
      chat.filter((value: any) => {
        return value?.title
          ?.toLowerCase()
          .includes(searchData?.toString().toLowerCase()) || !value.title;
      });

    data && setFilterChat && setFilterChat(filterByLastMessage(data));
  }, [searchData, chat]);

  return (
    <>
      {!showPersonalChat && (
        <div
          className={`helpHubChat animatedDissolve ${updateOutAnimation
            ? "updateOutAnimation"
            : updateOutTempAnimation
              ? "updateInAnimation"
              : ""
            }`}
        >
          <div className="q-custom-helphub-chatpage-upper-container">
            <div className="q-custom-helphub-chatpage-text-container">
              <div className="q-custom-helphub-chatpage-head-para">
                <div
                  className="q-custom-helphub-chatpage-heading"
                >
                  Chats
                </div>
                <div
                  className="q-custom-helphub-chatpage-para"
                >
                  Welcome back! Let us know how we can assist you.
                </div>
              </div>

              <div className="q-custom-helphub-chatpage-btn-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" onClick={() => { setHelpHub(false); isActive && isActive(false); onClose && onClose(false); }}>
                  <path d="M4.50586 11.4965L8.00119 8.00119L11.4965 11.4965M11.4965 4.50586L8.00053 8.00119L4.50586 4.50586" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>

          <div className="q-custom-helphub-chatpage-lower-container">
            {!fetchData && (
              <div className="q-custom-helphub-search-chats-container">
                <div className="custom-search-outer-div">
                  <div
                    className="q-custom-helphub-search-container-search"
                  >
                    <input
                      className="q-custom-helphub-search-input"
                      type="text"
                      placeholder="Search for help..."
                      onChange={(e) => {
                        setSearchData(e.target.value);
                      }}
                    />
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <g clip-path="url(#clip0_3321_77061)">
                        <circle cx="7.66732" cy="7.66732" r="6.33333" stroke="#9CA3AF" stroke-width="0.917045" />
                        <path d="M13.332 13.332L14.6654 14.6654" stroke="#9CA3AF" stroke-width="0.917045" stroke-linecap="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_3321_77061">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>

                {chat?.length == 0 && <div
                  className="q-custom-helphub-send-message"
                >
                  <div
                    onClick={() => {
                      setUpdateOutAnimation(true);
                      setScrollWidthSet((prev) => !prev);
                      setTimeout(() => {
                        setData(DEFAULT_MESSAGES);
                        setChatClosed(false);
                        setSelectedConversationId("");
                        setShowPersonalChat((prev) => !prev);
                        setShowBottomNavigation &&
                          setShowBottomNavigation((prev) => !prev);
                        setUpdateOneOutAnimation(false);
                        setScrollWidthSet((prev) => !prev);
                        setDisableSendMessageBtn(false);
                        setSendAutoMessage2("");
                      }, 100);
                    }}
                  >
                    <p
                    >
                      Message Now
                    </p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                      <path d="M14.4582 8.81672C14.7292 8.68121 14.9004 8.4042 14.9004 8.10118C14.9004 7.79816 14.7292 7.52115 14.4582 7.38564L3.25816 1.78564C2.9744 1.64376 2.63361 1.68296 2.38948 1.88557C2.14535 2.08818 2.04401 2.41591 2.13117 2.72096L3.27403 6.72095C3.37215 7.06439 3.68606 7.30117 4.04324 7.30117L7.70039 7.30117C8.14222 7.30117 8.50039 7.65934 8.50039 8.10117C8.50039 8.543 8.14222 8.90117 7.70039 8.90117H4.04325C3.68606 8.90117 3.37216 9.13795 3.27403 9.48139L2.13117 13.4814C2.04401 13.7864 2.14535 14.1142 2.38948 14.3168C2.63361 14.5194 2.9744 14.5586 3.25816 14.4167L14.4582 8.81672Z" fill="black" />
                    </svg>
                  </div>
                </div>}

                {/* chats  */}
                <div className="q-helphub-chats-section">
                  {!!chat?.length ? (
                    filterChat?.map((value: MessageTypes, index: number) => {
                      return (
                        <div
                          className="q-custom-helphub-chat-detail"
                          key={index}
                          onClick={() => {
                            setDisableSendMessageBtn(value.isClosed);
                            setChatClosed(value.isClosed);
                            setUpdateOutAnimation(true);
                            setScrollWidthSet((prev) => !prev);
                            getMessagesHistory(value?.conversationId);
                            setChat && setChat(chat.map(c => c.conversationId === value.conversationId ? { ...c, isReadByUser: true } : c));
                            setFilterChat && setFilterChat(filterChat.map(c => c.conversationId === value.conversationId ? { ...c, isReadByUser: true } : c));
                            setTimeout(() => {
                              setShowPersonalChat((prev) => !prev);
                              setShowBottomNavigation &&
                                setShowBottomNavigation((prev) => prev = false);
                              setUpdateOneOutAnimation(false);
                              setScrollWidthSet((prev) => !prev);
                            }, 100);
                          }}
                        >
                          <div className="q-helphub-chat-img-cont">
                            <img
                              src={entityImage || SenderImg}
                              alt=""
                              className="q-helphub-chat-sender-profile"
                            />
                          </div>

                          <div
                            className="q-custom-helphub-chat-message"
                            style={{
                              opacity: value?.isClosed == true ? 0.5 : 1,
                            }}
                          >
                            <div
                              className="q-custom-helphub-chat-sender-name"
                            >
                              Freedom Console
                            </div>
                            <div
                              className="q-custom-helphub-chat-sender-message"
                            >
                              {checkForCloseChat(value?.conversations?.content)
                                ?.closeChatTag == "CLOSE_CHAT"
                                ? checkForCloseChat(
                                  value?.conversations?.content
                                ).regularString || "Chat Closed"
                                : value?.conversations?.content}
                            </div>
                          </div>
                          {value?.isClosed == true && (
                            <p
                              className="q-helphub-closed-chat"
                            >
                              CLOSED
                            </p>
                          )}
                          {value.isReadByUser === false && <div className="custom-helphubBadge" />}
                          <div>

                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.67461 2.95437C5.88428 2.77465 6.19993 2.79893 6.37964 3.0086L10.3796 7.67526C10.5401 7.86251 10.5401 8.13881 10.3796 8.32606L6.37964 12.9927C6.19993 13.2024 5.88428 13.2267 5.67461 13.047C5.46495 12.8672 5.44067 12.5516 5.62038 12.3419L9.34147 8.00066L5.62038 3.65939C5.44067 3.44973 5.46495 3.13408 5.67461 2.95437Z" fill="#6B7280" stroke="#6B7280" stroke-width="0.6" stroke-linecap="round" />
                            </svg>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div
                      className="q-custom-helphub-chat-detail"
                      onClick={() => {
                        setUpdateOutAnimation(true);
                        setScrollWidthSet((prev) => !prev);
                        setData(DEFAULT_MESSAGES);
                        setTimeout(() => {
                          setShowPersonalChat((prev) => !prev);
                          setShowBottomNavigation &&
                            setShowBottomNavigation((prev) => !prev);
                          setUpdateOneOutAnimation(false);
                          setScrollWidthSet((prev) => !prev);
                        }, 100);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="q-helphub-chat-img-cont">
                        <HelphubSvg type="ava-icon" />
                      </div>

                      <div
                        className="q-custom-helphub-chat-message"
                        style={{ opacity: 1 }}
                      >
                        <div
                          className="q-custom-helphub-chat-sender-name"
                        >
                          Freedom Console
                        </div>
                        <div
                          className="q-custom-helphub-chat-sender-message"
                        >
                          Hi  I’m AVA, your AI assistant. How can I help you today?
                        </div>
                      </div>
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.67461 2.95437C5.88428 2.77465 6.19993 2.79893 6.37964 3.0086L10.3796 7.67526C10.5401 7.86251 10.5401 8.13881 10.3796 8.32606L6.37964 12.9927C6.19993 13.2024 5.88428 13.2267 5.67461 13.047C5.46495 12.8672 5.44067 12.5516 5.62038 12.3419L9.34147 8.00066L5.62038 3.65939C5.44067 3.44973 5.46495 3.13408 5.67461 2.95437Z" fill="#6B7280" stroke="#6B7280" stroke-width="0.6" stroke-linecap="round" />
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showPersonalChat && (
        <div
          className={`custom-quest-personal-chat-cont ${!updateOneoutAnimation ? "updateOneIn" : "updateOneOut"
            }`}
        >
          <div className="custom-quest-personal-chat-head-cont">
            <div className="custom-quest-head-back-cont">
              <div
                className="quest-back-btn"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOnlyAdminReply(false);
                  setData([]);
                  setTitle("");
                  setAdminMsg(false);
                  setScrollWidthSet((prev) => !prev);
                  setUpdateOneOutAnimation((prev) => !prev);
                  setUpdateOutTempAnimation(true);
                  setTimeout(() => {
                    setShowBottomNavigation && setShowBottomNavigation(true);
                    setUpdateOutAnimation(false);
                    setShowPersonalChat(false);
                  }, 250);
                }}
              >
                <HelphubSvg type={"BackButton"} />
              </div>
              <div
                className="custom-quest-labs-chat"
              >
                Freedom Console
              </div>
            </div>
          </div>

          <div
            className="custom-quest-chat-personal-conversion-cont"
            ref={scrollRef}
          >
            {!loading && (
              <div className="q-custom-chat-personal-container-body">
                <div className="text">
                  <div
                    className="q-custom-chat-personal-container-body-title"
                  >
                    How can I help?
                  </div>
                </div>

                <div className="q-custom-chat-personal-container-body-icons">
                  <HelphubSvg type={"ava-icon"} />
                </div>
              </div>
            )}

            <div className="custom-hepuhub-chat-container" id="chatContainer">
              {data &&
                data.map((message, index) => {
                  let chatSatisfied = JSON.parse(
                    localStorage.getItem("chatSatisfied") || "{}"
                  );

                  if (
                    message?.senderRole === "ADMIN" &&
                    checkForCloseChat(message.content)?.closeChatTag ===
                    "CLOSE_CHAT" &&
                    index < data.length - 1
                  ) {
                    return null;
                  }

                  if (
                    index == data.length - 1 &&
                    chatSatisfied[selectedConversationId] &&
                    chatSatisfied[selectedConversationId].isSatisfied &&
                    chatSatisfied[selectedConversationId].messegeId ==
                    message._id
                  ) {
                    return null;
                  }

                  return (
                    <div
                      style={{
                        display: "flex",
                        gap: "4.9px",
                        width: "100%"
                      }}
                      key={index}
                    >
                      {(message?.senderRole == "ASSISTANT" ||
                        message?.senderRole == "ADMIN" ||
                        message?.senderRole == "SYSTEM") && (
                          <HandleAdminChat
                            message={message}
                            entityImage={entityImage || QuestWhiteLogo}
                            index={index}
                            fontSize={styleConfig?.Chat?.Form?.fontSize || "14px"}
                            setOpenCloseChatPopup={setOpenCloseChatPopup}
                            setIfSatisfied={setIfSatisfied}
                            selectedConversationId={selectedConversationId}
                            setData={setData}
                            isAdminCloseChat={disableSendMessageBtn}
                            isCloseChatAdmin={isCloseChatAdmin}
                            setCloseChatAdmin={setCloseChatAdmin}
                            QuestThemeData={QuestThemeData}
                            styleConfig={styleConfig}
                          />
                        )}
                      {message?.senderRole === "USER" && (
                        <HandleUserChat
                          message={message}
                          index={index}
                          fontSize={styleConfig?.Chat?.Form?.fontSize || "14px"}
                          QuestThemeData={QuestThemeData}
                          BrandTheme={BrandTheme}
                          styleConfig={styleConfig}
                        />
                      )}
                    </div>
                  );
                })}

              {adminMsg && (
                <div
                  className="q-helphub-satisfied"
                  id="q-helphub-satisfied-admin-reply"
                >
                  <p>Please wait, Admin will get back to you soon.</p>
                </div>
              )}

              {senderMessageLoading && !onlyAdminReply && (
                <div className="q-chat-bubble-sdk">
                  <div className="typing">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </div>
              )}
            </div>

            {(data.length == 0 || (data.length == 2 && data[0]?.senderRole === "SYSTEM" && data[1]?.senderRole === "ASSISTANT")) && selectedConversationId.length === 0 && (
              <div
                className="custom-home-user-msg-2"
              >
                {defaultAutoPopupMessagesApi.map((ele, index) => {
                  return (
                    <p
                      key={index}
                      onClick={() => setSendAutoMessage2(ele)}
                    >
                      {ele}
                    </p>
                  );
                })}
              </div>
            )}
          </div>

          <div className="q-custom-chat-personal-container-footer">
            <div
              className={`${disableSendMessageBtn ? "send-message-chat-btn-disable" : ""}`}
            >
              <div className="q-custom-chat-personal-container-footer-inner">
                <input
                  className={`${disableSendMessageBtn ? "send-message-chat-btn-disable" : ""
                    } q-custom-chat-personal-container-footer-input`}
                  disabled={disableSendMessageBtn}
                  ref={messageInputRef}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      if (!isEnterToSend) return;
                      handleSave();
                    }
                  }}
                  placeholder="Ask a question..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <button
                  className={`${disableSendMessageBtn ? "send-message-aero-dsable" : ""
                    } sent-btn`}
                  onClick={handleSave}
                  aria-disabled={disableSendMessageBtn && !openEmailCollection}
                  disabled={message.length === 0}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                    <path d="M14.4582 8.81672C14.7292 8.68121 14.9004 8.4042 14.9004 8.10118C14.9004 7.79816 14.7292 7.52115 14.4582 7.38564L3.25816 1.78564C2.9744 1.64376 2.63361 1.68296 2.38948 1.88557C2.14535 2.08818 2.04401 2.41591 2.13117 2.72096L3.27403 6.72095C3.37215 7.06439 3.68606 7.30117 4.04324 7.30117L7.70039 7.30117C8.14222 7.30117 8.50039 7.65934 8.50039 8.10117C8.50039 8.543 8.14222 8.90117 7.70039 8.90117H4.04325C3.68606 8.90117 3.37216 9.13795 3.27403 9.48139L2.13117 13.4814C2.04401 13.7864 2.14535 14.1142 2.38948 14.3168C2.63361 14.5194 2.9744 14.5586 3.25816 14.4167L14.4582 8.81672Z" fill={message.length === 0 ? "white" : "black"} />
                  </svg>
                </button>
              </div>

              <div className="q-custom-chat-personal-container-footer-controller" onClick={() => {
                setIsEnterToSend(!isEnterToSend);
                localStorage.setItem("isEnterToSend", isEnterToSend ? "true" : "false");
              }}>
                <p>Enter to send</p>
                <input type="checkbox" name="" id="" checked={isEnterToSend} onChange={(e) => {
                  setIsEnterToSend(e.target.checked)
                  localStorage.setItem("isEnterToSend", e.target.checked ? "true" : "false");
                }} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomHelpHubChat;